'use strict'

const moduleConfig = require('../utils/module-config')

module.exports = (arg) => {
  const send = moduleConfig(arg)

  return {
    add: require('./add')(send),
    rm: require('./rm')(send),
    list: require('./list')(send)
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/bootstrap/index.js
// module id = 374
// module chunks = 0